{
  "instances": {
    "details": {
      "label": "Details",
      "cache": {
        "hit_ratio": "Hit ratio",
        "hits": "Hits",
        "misses": "Misses",
        "size": "Size"
      },
      "datasource": {
        "active_connections": "Active connections",
        "min_connections": "Min connections",
        "max_connections": "Max connections",
        "title": "Datasource: {dataSource}",
        "unlimited": "unlimited"
      },
      "gc": {
        "count": "Count",
        "count_short": "#",
        "time_spent_max": "Max time spent",
        "time_spent_max_short": "Max",
        "time_spent_total": "Total time spent",
        "time_spent_total_short": "Total",
        "title": "Garbage Collection Pauses"
      },
      "health": {
        "title": "Health",
        "toggle_details": "Toggle {name} health details"
      },
      "health_group": {
        "title": "Health Group"
      },
      "info": {
        "no_info_provided": "No info provided.",
        "title": "Info"
      },
      "memory": {
        "max": "Max",
        "metaspace": "Metaspace",
        "size": "Size",
        "title": "Memory",
        "used": "Used",
        "committed": "Committed"
      },
      "metadata": {
        "no_data_provided": "No metadata provided.",
        "title": "Metadata"
      },
      "process": {
        "cpus": "CPUs",
        "pid": "PID",
        "parent_pid": "Parent PID",
        "owner": "Owner",
        "process_cpu_usage": "Process CPU Usage",
        "process_cpu_usage_short": "CPU",
        "system_cpu_usage": "System CPU Usage",
        "system_cpu_usage_short": "Sys",
        "title": "Process",
        "uptime": "Uptime",
        "uptime_short": "Up"
      },
      "threads": {
        "daemon": "Daemon",
        "live": "Live",
        "peak_live": "Peak Live",
        "title": "Threads"
      }
    }
  }
}
